import { AuditModel } from 'modules/employees/audit-logs/types';
import { RootState } from 'store';

export const auditLogsLoadingSelector = (state: RootState): boolean => state.auditLogs.loading;
export const emoloyeeAuditLogSelector = (state: RootState): AuditModel[] => state.auditLogs.employeeAuditLogs;
